import React, { useEffect, useState } from 'react';
import UpArrow from '../../../assets/images/Up Arrow.svg';
import DownArrow from '../../../assets/images/Down Arrow.svg';
import Calender from '../../../assets/images/Calender.svg';
import DownloadFile from '../../../assets/images/Download File.svg';
import Capture from '../../../assets/images/capture 1.svg';
import FullScreen from '../../../assets/images/full-screen (3) 1.svg';
import MinimizeScreen from '../../../assets/images/minimize-solid.svg';
import ChartComponent from '../../../components/AreaChart';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import {
  ResponsiveContainer,
  AreaChart,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Area,
} from 'recharts';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Link,
  TextField,
  PopperProps,
  Skeleton,
} from '@mui/material';
import { useHook as equipmentHook } from './useHook';
import { useParams } from 'react-router-dom';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import dayjs, { Dayjs } from 'dayjs';
import CSVExportBtn from '../../../components/CSVExportBtn/index';
import { Unauthorized } from '../../../components';

// Define the data type for the chart data
interface DataPoint {
  name: string;
  w: number;
}

// Example data
const areaData: DataPoint[] = [
  { name: 'Mon', w: 400 },
  { name: 'Tue', w: 300 },
  { name: 'Wed', w: 200 },
  { name: 'Thu', w: 278 },
  { name: 'Fri', w: 189 },
  { name: 'Sat', w: 239 },
  { name: 'Sun', w: 349 },
];

// Define the tooltip prop types
interface CustomToolTipProps {
  active?: boolean;
  payload?: { value: number }[];
  label?: string;
}

const CustomToolTipOfTotalPower: React.FC<CustomToolTipProps> = ({
  active,
  payload,
  label,
}) => {
  if (active && payload && payload?.length) {
    return (
      <div className="custom-tooltip">
        <p className="label">{`${label}`}</p>
        <p className="tooltip_value">{`${payload[0].value}`}</p>
      </div>
    );
  }
  return null;
};

interface ReadableParameterListProps {
  equipmentDetailsData: any;
  setRefreshFunction?: (func: () => void) => void;
}
const ReadableParameterList: React.FC<ReadableParameterListProps> = ({
  equipmentDetailsData,
  setRefreshFunction,
}) => {
  const { fetchReadTimeSerieseParameter, fetchReadUnitParameter } =
    equipmentHook();
  const { id } = useParams();
  const [ParameterList, setParameterList] = useState<any[]>([]);
  const [chardViewAccess, setChardViewAccess] = useState(true);
  const [chartData, setChartData] = useState<any>([]);
  const [selectParamData, setSelectParamData] = useState<any>(null);
  const [readUnitParameterData, setReadUnitParameterData] = useState<any>({});
  const [openExpandPopup, setOpenExpandPopup] = useState(false);
  const [dateAnchorEl, setDateAnchorEl] = useState<null | HTMLElement>(null);
  const [startDateValue, setStartDateValue] = React.useState<Dayjs | any>(
    dayjs().startOf('day'),
  );
  const [endDateValue, setEndDateValue] = React.useState<Dayjs | any>(dayjs());
  const [csvChartData, setCsvChartData] = useState<any>([]);
  const [startDateOpen, setStartDateOpen] = useState(false);
  const [endDateOpen, setEndDateOpen] = useState(false);
  const [expandStartDateOpen, setExpandStartDateOpen] = useState(false);
  const [expandEndDateOpen, setExpandEndDateOpen] = useState(false);
  const [loadingChart, setLoadingChart] = useState(true);

  useEffect(() => {
    if (setRefreshFunction) {
      setRefreshFunction(handleRefreshFunction);
    }
  }, [setRefreshFunction]);

  useEffect(() => {
    const windowHeight = window.innerHeight;
    const resultHeight = windowHeight - 200;

    // Set the CSS variable dynamically on the root element
    document.documentElement.style.setProperty(
      '--result-height',
      `${resultHeight}px`,
    );
  }, []);

  //chartdata timeconvert
  function adjustForLocalTimeZone(timestamp: number) {
    const date = new Date(timestamp * 1000); // Convert to milliseconds
    const localOffset = date.getTimezoneOffset() * 60; // Time zone offset in seconds
    return timestamp - localOffset; // Adjust timestamp to match local time
  }
  //csvChartData timeconvert
  const formatTime = (timestamp: number) => {
    if (timestamp) {
      return dayjs.unix(timestamp).format('DD MMM YYYY h:mm:ss A');
    }
  };

  // Generate data from start to end date
  const generateChartData = (start: any, end: any) => {
    const data: { time: any; value: any }[] = [];

    for (let timestamp: any = start; timestamp <= end; timestamp += 3600) {
      //3600 seconds in a hour
      // 86400 seconds in a day
      data.push({
        time: timestamp,
        value: NaN, // Placeholder value, can be replaced or filled with actual data later
      });
    }

    return data;
  };

  // Function to merge and remove duplicates
  function mergeAndRemoveDuplicates(original: any, newEntries: any) {
    // Combine the original and new data
    const combined = [...original, ...newEntries];
    // Create a map to keep the most recent value for each time
    const uniqueMap = new Map();

    combined.forEach((entry) => {
      if (
        !uniqueMap.has(entry.time) ||
        uniqueMap.get(entry.time).timestamp < entry.timestamp
      ) {
        uniqueMap.set(entry.time, entry);
      }
    });

    // Convert the map values to an array
    return Array.from(uniqueMap.values());
  }

  const expandScreenPopup = () => {
    setOpenExpandPopup(true);
  };
  const handleClose = () => {
    setOpenExpandPopup(false);
  };

  //selectParam
  const handleSelectParam = (data: any) => {
    setSelectParamData(data);
    getChartData(data, startDateValue, endDateValue);
  };

  const callAgainChartData = async (
    variableName: any,
    startDateTime: any,
    endDateTime: any,
    generateDummyChartData: any,
    renderChartData: any,
    renderCsvChartData: any,
  ) => {
    const payload = {
      unitID: id,
      from: startDateTime,
      to: endDateTime,
      // limit: 7,
      variable: variableName || '',
    };
    await fetchReadTimeSerieseParameter(payload)
      .then((response: any) => {
        if (response?.data) {
          const chartData = response?.data?.map((data: any) => ({
            time: adjustForLocalTimeZone(data?.timestamp),
            value: data?.value,
          }));
          const csvChartData = response?.data
            ?.map((item: any) => ({
              ...item,
              time: formatTime(item?.timestamp),
            }))
            .sort(
              (a: { timestamp: number }, b: { timestamp: number }) =>
                a.timestamp - b.timestamp,
            );
          const callAgainRenderData = [...renderChartData, ...chartData];
          const callAgainRenderCsvData = [
            ...renderCsvChartData,
            ...csvChartData,
          ];
          if (
            response?.endTime !== payload?.to &&
            response?.endTime < payload?.to
          ) {
            callAgainChartData(
              variableName,
              payload?.from,
              response?.startTime,
              generateDummyChartData,
              callAgainRenderData,
              callAgainRenderCsvData,
            );
          } else {
            const finalChartData = mergeAndRemoveDuplicates(
              callAgainRenderData,
              generateDummyChartData,
            )?.sort(
              (a: { time: number }, b: { time: number }) => a.time - b.time,
            );
            setCsvChartData(callAgainRenderCsvData);
            setChartData(finalChartData);
            setLoadingChart(false);
          }
        }
      })
      .catch(() => {
        setLoadingChart(false);
      });
  };

  const getChartData = async (
    data: any,
    startDateTime: any,
    endDateTime: any,
  ) => {
    const payload = {
      unitID: id,
      from: startDateTime?.unix() || null,
      to: endDateTime?.unix() || null,
      // limit: 7,
      variable: data?.variableName || '',
    };
    setLoadingChart(true);
    await fetchReadTimeSerieseParameter(payload)
      .then((response: any) => {
        if (response?.data) {
          const generateDummyChartData = generateChartData(
            startDateTime?.unix(),
            endDateTime?.unix(),
          );
          const chartData = response?.data?.map((data: any) => ({
            time: adjustForLocalTimeZone(data?.timestamp),
            value: data?.value,
          }));

          const csvChartData = response?.data
            ?.map((item: any) => ({
              ...item,
              time: formatTime(item?.timestamp),
            }))
            .sort(
              (a: { timestamp: number }, b: { timestamp: number }) =>
                a.timestamp - b.timestamp,
            );

          if (
            response?.endTime !== payload?.to &&
            response?.endTime < payload?.to
          ) {
            callAgainChartData(
              data?.variableName,
              payload?.from,
              response?.startTime,
              generateDummyChartData,
              chartData,
              csvChartData,
            );
          } else {
            const finalChartData = mergeAndRemoveDuplicates(
              chartData,
              generateDummyChartData,
            )?.sort(
              (a: { time: number }, b: { time: number }) => a.time - b.time,
            );
            setCsvChartData(csvChartData);
            setChartData(finalChartData);
            setLoadingChart(false);
          }
        } else {
          console.error('Unexpected response format:', response);
          const generateDummyChartData = generateChartData(
            startDateTime?.unix(),
            endDateTime?.unix(),
          );
          const finalChartData = mergeAndRemoveDuplicates(
            [],
            generateDummyChartData,
          )?.sort(
            (a: { time: number }, b: { time: number }) => a.time - b.time,
          );
          setChartData(finalChartData);
          setCsvChartData([]);
          setLoadingChart(false);
        }
        const paramPayload = JSON.stringify({
          from: startDateTime || null,
          to: endDateTime || null,
          variable: data,
        });
        sessionStorage.setItem('paramPayload', paramPayload);
      })
      .catch((error) => {
        console.log(error.message, 'errormessage');
        setLoadingChart(false);
      });
  };

  //Get ReadUnitParameter
  const getreadUnitParameter = async () => {
    await fetchReadUnitParameter({ unitID: id })
      .then((response) => {
        setReadUnitParameterData(response);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // const initialData = [
  //   { time: new Date(2023, 5, 1, 14).getTime() / 1000, value: 50 }, // June is month 5 (zero-based index)
  //   { time: new Date(2023, 5, 3, 4).getTime() / 1000, value: 55 },
  //   { time: new Date(2023, 5, 3, 5).getTime() / 1000, value: 60 },
  //   { time: new Date(2023, 6, 6, 1).getTime() / 1000, value: 65 }, // July is month 6 (zero-based index)
  //   { time: new Date(2023, 6, 6, 2).getTime() / 1000, value: 70 },
  // ];
  const chartColors = {
    backgroundColor: 'white',
    lineColor: '#2B7FFF',
    textColor: 'black',
    areaTopColor: 'rgb(35 119 252)',
    areaBottomColor: 'rgb(35 119 252 / 0%)',
  };

  const handleZoomFunction = (data: any) => {
    console.log(data, 'zooming data from parend');
  };

  const handleDragFunction = (data: any) => {
    console.log(data, 'Drag data from parend');
  };

  useEffect(() => {
    if (equipmentDetailsData) {
      setParameterList(equipmentDetailsData?.readableParameters || []);
    }
  }, [equipmentDetailsData]);

  useEffect(() => {
    if (equipmentDetailsData?.readableParameters?.length > 0) {
      // Retrieve the JSON string from sessionStorage
      const paramPayload = sessionStorage.getItem('paramPayload');

      // Parse the JSON string to an object, or set to null if parsing fails
      const paramPayloadObject = paramPayload ? JSON.parse(paramPayload) : null;
      if (paramPayloadObject) {
        handleRefreshFunction();
      } else {
        setSelectParamData(equipmentDetailsData?.readableParameters[0]);
        setStartDateValue(dayjs().startOf('day'));
        setEndDateValue(dayjs());
        getChartData(
          equipmentDetailsData?.readableParameters[0],
          dayjs().startOf('day'),
          dayjs(),
        );
      }
      getreadUnitParameter();
    }
  }, [equipmentDetailsData, id]);

  const handleSubmitTime = () => {
    if (dayjs(startDateValue).isValid() && dayjs(endDateValue).isValid()) {
      getChartData(selectParamData, startDateValue, endDateValue);
    }
  };

  const handleStartDateTimeChange = (newValue: any) => {
    const currentTime = dayjs();
    if (newValue && dayjs(newValue).isAfter(currentTime)) {
      setStartDateValue(dayjs().startOf('day')); // Set to current time if greater than current time
    } else {
      setStartDateValue(newValue);
    }

    if (
      endDateValue &&
      newValue &&
      dayjs(newValue).isAfter(dayjs(endDateValue))
    ) {
      setEndDateValue(null); // Reset end time if start time exceeds it
      setStartDateValue(dayjs().startOf('day')); // Set to current time if greater than current time
    }
  };
  const handleEndDateTimeChange = (newValue: any) => {
    const currentTime = dayjs();
    if (
      startDateValue &&
      newValue &&
      dayjs(newValue).isBefore(dayjs(startDateValue))
    ) {
      setEndDateValue(null);
      // alert('End date and time cannot be before the start date and time.');
    } else if (newValue && dayjs(newValue).isAfter(currentTime)) {
      setEndDateValue(currentTime); // Set to current time if greater than current time
    } else {
      setEndDateValue(newValue);
    }
  };
  //format Date
  const DisplayFormattedDate = (dateTime: string | Date) => {
    // Format the date to "DD MMM YYYY | h:mm A"
    return dayjs(dateTime).format('DD MMM YYYY | h:mm A') || '';
  };

  const shouldDisableStartDate = (date: {
    isAfter: (arg0: any) => any;
    isBefore: (arg0: dayjs.Dayjs) => any;
  }) => {
    if (!endDateValue) {
      return false; // No startDate selected, so don't disable any dates
    }
    return date.isAfter(endDateValue);
  };

  //csv file downloader
  const csvHeader = [
    { label: 'Time', key: 'time' },
    { label: 'Value', key: 'value' },
  ];

  const handleRefreshFunction = () => {
    // Retrieve the JSON string from sessionStorage
    const paramPayload = sessionStorage.getItem('paramPayload');

    // Parse the JSON string to an object, or set to null if parsing fails
    const paramPayloadObject = paramPayload ? JSON.parse(paramPayload) : null;

    // Check if paramPayloadObject is valid and contains valid date fields
    if (paramPayloadObject) {
      const fromDate = paramPayloadObject.from
        ? dayjs(paramPayloadObject.from)
        : null;
      const toDate = paramPayloadObject.to
        ? dayjs(paramPayloadObject.to)
        : null;
      // Validate date fields
      if (fromDate && fromDate?.isValid() && toDate && toDate?.isValid()) {
        // Set state values with the retrieved data
        setSelectParamData(paramPayloadObject?.variable);
        setStartDateValue(fromDate);
        setEndDateValue(toDate);

        // Fetch chart data with the retrieved parameters
        getChartData(paramPayloadObject?.variable, fromDate, toDate);
      }
    }
  };

  const findReadParamValue = (paramName: any) => {
    for (let i = 0; i < readUnitParameterData?.length; i++) {
      if (readUnitParameterData[i][paramName] !== undefined) {
        return readUnitParameterData[i][paramName];
      }
    }
    return null; // Return null if varname not found
  };

  const findReadParamTimestamp = (paramName: any) => {
    for (let i = 0; i < readUnitParameterData?.length; i++) {
      if (readUnitParameterData[i][paramName] !== undefined) {
        return readUnitParameterData[i].timestamp;
      }
    }
    return null; // Return null if varname not found
  };

  return ParameterList?.length > 0 ? (
    <section className="equipment_information">
      <h5>Readable Parameter List</h5>
      {equipmentDetailsData?.subscriptionStatus === 'active' ? (
        <>
          <p>
            Last Updated on{' '}
            {formatTime(findReadParamTimestamp(selectParamData?.variableName))}
          </p>
          <div className="equipment_information-content equipment_parameter_list">
            <div className="equipment_parameter_list-card_container">
              {equipmentDetailsData?.readableParameters?.map(
                (data: any, index: number) => (
                  <Button
                    key={index}
                    className={
                      data?.parameterName === selectParamData?.parameterName
                        ? 'equipment_parameter_list-card equipment_parameter_list-card-active'
                        : ' equipment_parameter_list-card'
                    }
                    onClick={() => handleSelectParam(data)}
                  >
                    <div className="equipment_parameter_list-card-value">
                      <div>
                        <h5>
                          {findReadParamValue(data?.variableName)?.toFixed(
                            data.decimals,
                          ) || ''}
                        </h5>
                        <h5>{data?.unit || ''}</h5>
                      </div>

                      {/* <img
                    src={
                      readUnitParameterData?.[data?.parameterName]
                        ? UpArrow
                        : DownArrow
                    }
                    alt="arrow"
                    width="20"
                  /> */}
                    </div>

                    <h6>{data?.parameterName || ' '}</h6>
                  </Button>
                ),
              )}
            </div>

            <div className="equipment_parameter_list-chart_container">
              <h5>{selectParamData?.parameterName || ' '}</h5>
              <div className="equipment_parameter_list-chart-card">
                <header className="equipment_parameter_list-chart-card_header">
                  {/* <Button
                className="equipment_parameter_list-chart-card_header-datefield"
                aria-describedby={dateId}
                variant="contained"
                onClick={handleOpenDate}
              >
                <img src={Calender} alt="Calender" width="20" />{' '}
                {DisplayFormattedDate(submitDateValue?.startDateValue)}{' '}
                &nbsp;&nbsp; To &nbsp;&nbsp;{' '}
                {DisplayFormattedDate(submitDateValue?.endDateValue)}
              </Button> */}
                  <div className="equipment_parameter_list-chart-card_header-timepicker">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DateTimePicker
                        value={startDateValue}
                        onChange={handleStartDateTimeChange}
                        shouldDisableDate={shouldDisableStartDate}
                        maxDateTime={dayjs()}
                        open={startDateOpen}
                        onOpen={() => setStartDateOpen(true)}
                        onClose={() => setStartDateOpen(false)}
                        slotProps={{
                          textField: {
                            onClick: () => setStartDateOpen(true),
                          },
                          popper: {
                            modifiers: [
                              {
                                name: 'flip',
                                enabled: false,
                              },
                              {
                                name: 'preventOverflow',
                                options: {
                                  altBoundary: true,
                                  tether: false,
                                  rootBoundary: 'viewport',
                                },
                              },
                            ],
                          },
                        }}
                      />
                    </LocalizationProvider>

                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DateTimePicker
                        value={endDateValue}
                        onChange={handleEndDateTimeChange}
                        disabled={!startDateValue}
                        minDateTime={startDateValue && startDateValue}
                        maxDateTime={dayjs()}
                        open={endDateOpen}
                        onOpen={() => setEndDateOpen(true)}
                        onClose={() => setEndDateOpen(false)}
                        slotProps={{
                          textField: {
                            onClick: () => setEndDateOpen(true),
                          },
                          popper: {
                            modifiers: [
                              {
                                name: 'flip',
                                enabled: false,
                              },
                              {
                                name: 'preventOverflow',
                                options: {
                                  altBoundary: true,
                                  tether: false,
                                  rootBoundary: 'viewport',
                                },
                              },
                            ],
                          },
                        }}
                      />
                    </LocalizationProvider>
                    <Button
                      className="parameter_time_popup-submit"
                      onClick={handleSubmitTime}
                      disabled={
                        !dayjs(startDateValue).isValid() ||
                        !dayjs(endDateValue).isValid() ||
                        !selectParamData
                      }
                    >
                      Submit
                    </Button>
                  </div>

                  <div className="equipment_parameter_list-chart-card_header-btn_container">
                    <CSVExportBtn
                      headers={csvHeader}
                      csvData={csvChartData ? csvChartData : []}
                      label={<img src={DownloadFile} alt="arrow" width="20" />}
                      prifix="_readable_parameter"
                    />
                    {/* <Button>
                  <img src={DownloadFile} alt="arrow" width="20" />
                </Button> */}
                    {/* <Button>
                  <img src={Capture} alt="arrow" width="20" />
                </Button> */}
                    <Button onClick={expandScreenPopup}>
                      <img src={FullScreen} alt="arrow" width="20" />
                    </Button>
                  </div>
                </header>
                <div className="equipment_parameter_list-chart-card-data">
                  {/* {!chardViewAccess && (
                <div className="equipment_parameter_list-chard-without_access">
                  <div className="equipment_parameter_list-chard-without_access-card">
                    <p>
                      You have not permission to view this chart. <br />
                      Please contact to your admin partner.
                    </p>
                  </div>
                </div>
              )} */}
                  {loadingChart ? (
                    <Skeleton
                      variant="rectangular"
                      sx={{ borderRadius: '10px' }}
                      width={'100%'}
                      height={'100%'}
                    />
                  ) : (
                    <ChartComponent
                      handleZoomFunction={handleZoomFunction}
                      handleDragFunction={handleDragFunction}
                      colors={chartColors}
                      data={chartData}
                    ></ChartComponent>
                  )}

                  {/* <ResponsiveContainer width="100%" height="100%">
                <AreaChart
                  data={areaData}
                  margin={{
                    top: 5,
                    right: 30,
                    left: 20,
                    bottom: 5,
                  }}
                >
                  <defs>
                    <linearGradient
                      id="colorAreaChart"
                      x1="0"
                      y1="0"
                      x2="0"
                      y2="1"
                    >
                      <stop
                        offset="5%"
                        stopColor="rgb(35 119 252)"
                        stopOpacity={0.1}
                      />
                      <stop
                        offset="95%"
                        stopColor="rgb(35 119 252 / 0%)"
                        stopOpacity={0.1}
                      />
                    </linearGradient>
                  </defs>
                  <XAxis
                    dataKey="name"
                    fontSize={14}
                    fontWeight={400}
                    tick={{ fill: '#667085' }}
                    interval={2}
                    tickLine={false}
                    axisLine={false}
                  />
                  <YAxis
                    fontSize={14}
                    fontWeight={400}
                    tick={{ fill: '#667085' }}
                    tickLine={false}
                    axisLine={false}
                  />
                  <CartesianGrid vertical={false} stroke="#DDD" />
                  <Tooltip
                    wrapperStyle={{ outline: 'none' }}
                    cursor={false}
                    content={<CustomToolTipOfTotalPower />}
                  />
                  <Area
                    type="monotone"
                    dataKey="w"
                    stroke="rgb(43 127 255)"
                    fillOpacity={1}
                    fill="url(#colorAreaChart)"
                  />
                </AreaChart>
              </ResponsiveContainer> */}
                </div>
              </div>
            </div>

            <Dialog
              fullScreen
              className="expand-popup"
              open={openExpandPopup}
              onClose={handleClose}
              aria-labelledby="delete-dialog-title"
              aria-describedby="delete-dialog-description"
              fullWidth
              maxWidth="xl"
              sx={{
                '& .MuiDialog-paper': {
                  borderRadius: '0px',
                  height: '100vh',
                  width: '100vw',
                  margin: 0,
                  padding: 0,
                },
              }}
            >
              <DialogContent>
                <div className="equipment_parameter_list-chart_container">
                  <div className="equipment_parameter_header">
                    <h5>{`${selectParamData?.parameterName} - ${equipmentDetailsData.equipmentName}   ${
                      findReadParamValue(
                        selectParamData?.variableName,
                      )?.toFixed(selectParamData.decimals) || ''
                    }`}</h5>
                    {/* <IconButton onClick={handleClose}>
                  <CloseRoundedIcon />
                </IconButton> */}
                  </div>

                  <div className="equipment_parameter_list-chart-card">
                    <header className="equipment_parameter_list-chart-card_header">
                      <div className="equipment_parameter_list-chart-card_header-timepicker">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DateTimePicker
                            value={startDateValue}
                            onChange={handleStartDateTimeChange}
                            shouldDisableDate={shouldDisableStartDate}
                            maxDateTime={dayjs()}
                            open={expandStartDateOpen}
                            onOpen={() => setExpandStartDateOpen(true)}
                            onClose={() => setExpandStartDateOpen(false)}
                            slotProps={{
                              textField: {
                                onClick: () => setExpandStartDateOpen(true),
                              },
                              popper: {
                                modifiers: [
                                  {
                                    name: 'flip',
                                    enabled: false,
                                  },
                                  {
                                    name: 'preventOverflow',
                                    options: {
                                      altBoundary: true,
                                      tether: false,
                                      rootBoundary: 'viewport',
                                    },
                                  },
                                ],
                              },
                            }}
                          />
                        </LocalizationProvider>

                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DateTimePicker
                            value={endDateValue}
                            onChange={handleEndDateTimeChange}
                            disabled={!startDateValue}
                            minDateTime={startDateValue && startDateValue}
                            maxDateTime={dayjs()}
                            open={expandEndDateOpen}
                            onOpen={() => setExpandEndDateOpen(true)}
                            onClose={() => setExpandEndDateOpen(false)}
                            slotProps={{
                              textField: {
                                onClick: () => setExpandEndDateOpen(true),
                              },
                              popper: {
                                modifiers: [
                                  {
                                    name: 'flip',
                                    enabled: false,
                                  },
                                  {
                                    name: 'preventOverflow',
                                    options: {
                                      altBoundary: true,
                                      tether: false,
                                      rootBoundary: 'viewport',
                                    },
                                  },
                                ],
                              },
                            }}
                          />
                        </LocalizationProvider>
                        <Button
                          className="parameter_time_popup-submit"
                          onClick={handleSubmitTime}
                          disabled={
                            !dayjs(startDateValue).isValid() ||
                            !dayjs(endDateValue).isValid() ||
                            !selectParamData
                          }
                        >
                          Submit
                        </Button>
                      </div>
                      {/* <div className="equipment_parameter_list-chart-card_header-datefield">
                    <img src={Calender} alt="Calender" width="20" />{' '}
                    {DisplayFormattedDate(submitDateValue?.startDateValue)}{' '}
                    &nbsp;&nbsp; To &nbsp;&nbsp;{' '}
                    {DisplayFormattedDate(submitDateValue?.endDateValue)}
                  </div> */}

                      <div className="equipment_parameter_list-chart-card_header-btn_container">
                        <CSVExportBtn
                          headers={csvHeader}
                          csvData={csvChartData ? csvChartData : []}
                          label={
                            <img src={DownloadFile} alt="arrow" width="20" />
                          }
                          prifix="_readable_parameter"
                        />
                        {/* <Button>
                      <img src={DownloadFile} alt="arrow" width="20" />
                    </Button> */}
                        {/* <Button>
                      <img src={Capture} alt="arrow" width="20" />
                    </Button> */}
                        <Button onClick={handleClose}>
                          <img src={MinimizeScreen} alt="arrow" width="20" />
                        </Button>
                      </div>
                    </header>
                    <div className="equipment_parameter_list-chart-card-data">
                      {loadingChart ? (
                        <Skeleton
                          variant="rectangular"
                          sx={{ borderRadius: '10px' }}
                          width={'100%'}
                          height={'100%'}
                        />
                      ) : (
                        <ChartComponent
                          handleZoomFunction={handleZoomFunction}
                          handleDragFunction={handleDragFunction}
                          colors={chartColors}
                          data={chartData}
                        ></ChartComponent>
                      )}
                    </div>
                  </div>
                </div>
              </DialogContent>
            </Dialog>
          </div>

          {/* <Popover
        className="parameter_time_popup"
        id={dateId}
        open={dateOpen}
        anchorEl={dateAnchorEl}
        // onClose={handleDateClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <div className="parameter_time_popup-contant">
          <div>
            <h4>Start Date</h4>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={['DateTimePicker']}>
                <DateTimePicker
                  value={startDateValue}
                  defaultValue={submitDateValue?.startDateValue}
                  onChange={handleStartDateTimeChange}
                />
              </DemoContainer>
            </LocalizationProvider>
          </div>

          <div>
            <h4>End Date</h4>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={['DateTimePicker']}>
                <DateTimePicker
                  value={endDateValue}
                  defaultValue={submitDateValue?.endDateValue}
                  onChange={handleEndDateTimeChange}
                />
              </DemoContainer>
            </LocalizationProvider>
          </div>
        </div>
        <div className="parameter_time_popup-actions">
          <Button
            className="parameter_time_popup-cancel"
            onClick={handleDateClose}
          >
            Cancel
          </Button>
          <Button
            className="parameter_time_popup-submit"
            onClick={handleSubmitTime}
            disabled={!startDateValue || !endDateValue}
          >
            Submit
          </Button>
        </div>
      </Popover> */}
        </>
      ) : (
        // <p className="edit_access_error">
        //   * You cannot view parameter value . Please contact to your admin
        //   partner.
        // </p>
        <Unauthorized
          message={
            'Your subscription is inactive. Please activate it to view the details.'
          }
        />
      )}
    </section>
  ) : (
    <></>
  );
};

const MemoizedComponent = React.memo(ReadableParameterList);
export default MemoizedComponent;
